export const FILTERS = [
  { id: "all", label: "All" },
  { id: "photo", label: "Photos" },
  { id: "video", label: "Videos" },
];

export const VIDEO_FRAME_CAPTURE_TIME = 1.25;

export const GALLERY_MEDIA = [
  {
    id: 1,

    type: "photo",
    src: "/gallery/g1.webp",
    caption:
      "Players sharpening close control during a high-tempo training block.",
  },
  {
    id: 2,
    type: "photo",
    src: "/gallery/g2.webp",
    caption:
      "A matchday moment that captures the academy's intensity and discipline.",
  },
  {
    id: 3,
    type: "video",
    src: "/gallery/matchday.mp4",
    caption:
      "Matchday action from the academy with the right thumbnail and full clip.",
  },
  {
    id: 4,
    type: "photo",
    src: "/gallery/g4.webp",
    caption:
      "Technical repetition on the ball with focus on clean first touches.",
  },
  {
    id: 5,
    type: "video",
    src: "/gallery/macthTraining.mp4",
    caption:
      "Training-ground footage showing intensity, movement, and repetition on the pitch.",
  },
  {
    id: 6,
    type: "photo",
    src: "/gallery/g6.webp",
    caption:
      "Academy culture built around effort, teamwork, and composure under pressure.",
  },
  {
    id: 7,
    type: "video",
    src: "/gallery/matchdayTraining.mp4",
    caption:
      "A closer look at match-prep work and the tempo expected in every session.",
  },
  {
    id: 8,
    type: "photo",
    src: "/gallery/g3.webp",
    caption:
      "Another still from academy action, capturing sharp movement and focus in play.",
  },
  {
    id: 9,
    type: "photo",
    src: "/gallery/g5.webp",
    caption:
      "Training energy on the pitch with players working through game scenarios.",
  },
  {
    id: 10,
    type: "photo",
    src: "/gallery/g7.webp",
    caption:
      "Another snapshot from development sessions built for confident play.",
  },
];
